import uniqid from 'uniqid'
import { relevantCourseWork } from '../../portfolio'
import './RelevantCourseWork.css'

const RelevantCourseWork = () => {
  if (!relevantCourseWork.length) return null

  return (
    <section className='section skills'>
      <h2 className='section__title'>Relevant CourseWork</h2>
      <div className="coursework">
        {
            relevantCourseWork.map((e) =>
                <div className="lesson">
                    <p className='lesson-title'>{e.name}</p>
                    <div className='grade'>
                        <p className="grade-title">GPA&nbsp;&nbsp;:&nbsp;&nbsp;</p>
                        <p className="gpa-grade-value">{e.gradeGpa}/4</p>
                        <p className="grade-value">({e.grade}/20)</p>
                    </div>
                </div>
            )
        }
      </div>
    </section>
  )
}

export default RelevantCourseWork
